export default {
  id: 'ID: {{id}}',
  btnOpenMap: 'Open Map',
  driver: 'Driver: {{driver}}',
  car: 'Car: {{car}}',
  service: 'Service: {{service}}',
  seats: 'Seats',
  seat: 'Seat',
  distance: 'Distance',
  distanceUnit: {
    km: 'km',
    mi: 'mi',
  },
  duration: 'Duration',
  durationUnit: {
    mimute: 'm',
  },
};
